import { Box } from "theme-ui";

export default function ArrowDownIcon(props) {
  return (
    <Box
      as="svg"
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 1V25"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M1 13L13 25L25 13"
        stroke="#808080"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Box>
  );
}
